import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ModalBox from "../../../../common/component/Modal/Index";
import { path } from "../../../../constants/apiPath";
import routeConstant from "../../../../../route/compoent/routeConstant";
import { StoreContext } from "../../../../store";
import OrderDone_svg from "../../../../svg/svg-modal/OrderDone_svg";
import orderObject from "../../../../constants/data/orderCreation";

function ConfirmModal(props) {
  const context = useContext(StoreContext);
  const navigate = useNavigate();
  // const location = useLocation();

  useEffect(() => {
    return () => {
      context.setModalOpen(false);
    };
  }, []);

  return (
    <ModalBox>
      <div className="_modalBody">
        <div className="_modalSvg">
          <OrderDone_svg />
        </div>
        <p className="_modalText">{props.msg}</p>
      </div>
      <div className="_modalFooter justify-content-center">
        <div className="_solidButton">
          <button
            onClick={() => {
              context.setModalOpen(false);
              // navigate(-4);
              navigate(routeConstant.ORDER_DASHBOARD);
            }}
          >
            Okay
          </button>
        </div>
      </div>
    </ModalBox>
  );
}

export default ConfirmModal;
